(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- reveals (robust: also reveal anything already near the fold) ----
  var els=[].slice.call(document.querySelectorAll('.reveal,.wipe'));
  function showIfNear(){var vh=window.innerHeight;els=els.filter(function(el){if(el.getBoundingClientRect().top<vh*0.9){el.classList.add('in');return false;}return true;});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(el){io.observe(el);}); showIfNear();
  window.addEventListener('scroll',showIfNear,{passive:true});

  // ---- mobile nav: hamburger toggle for the header menu ----
  (function(){
    var toggle=document.getElementById('menuToggle');
    var nav=document.getElementById('siteNav');
    if(!toggle||!nav) return;
    function closeMenu(){ nav.classList.remove('open'); toggle.setAttribute('aria-expanded','false'); }
    function openMenu(){ nav.classList.add('open'); toggle.setAttribute('aria-expanded','true'); }
    toggle.addEventListener('click',function(){
      nav.classList.contains('open') ? closeMenu() : openMenu();
    });
    [].slice.call(nav.querySelectorAll('a')).forEach(function(a){ a.addEventListener('click',closeMenu); });
    document.addEventListener('click',function(e){
      if(nav.classList.contains('open') && !nav.contains(e.target) && e.target!==toggle && !toggle.contains(e.target)){
        closeMenu();
      }
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeMenu(); });
    window.addEventListener('resize',function(){ if(window.innerWidth>780) closeMenu(); });
  })();

  // ---- hero slider: GSAP-powered dissolve (blur+scale crossfade), with a
  // brightness pulse through the day-colour arc and a soft kanji breathe,
  // synced to every slide change. Falls back to an instant swap if GSAP
  // didn't load, or if the visitor prefers reduced motion. Slides whose
  // scene has a background video wait for that video's 'ended' event
  // before advancing, instead of using the fixed timer. ----
  (function(){
    var slides=[].slice.call(document.querySelectorAll('.hslide'));
    var dots=[].slice.call(document.querySelectorAll('.hdot'));
    if(slides.length<2) return;
    var cur=0,timer=null,DUR=6200,animating=false;
    var heroArc=document.querySelector('.hero-arc');
    var heroKanji=document.querySelector('.hero-kanji');
    var heroFog=document.querySelector('.hero-fog');
    var scenes=[].slice.call(document.querySelectorAll('.hero-scene'));
    var hasGsap=(typeof gsap!=='undefined');

    // ---- per-slide video sound: defaults to ON (per product request). Most
    // browsers block unmuted autoplay without a prior user gesture, so this
    // is best-effort — if the browser's play() promise rejects, we fall back
    // to muted playback and let the toggle below be the real, always-allowed
    // way to turn sound on (a click is a genuine user gesture). The toggle
    // only appears when the active slide actually has a video, and always
    // reflects that video's true muted state — it never claims sound is on
    // when the browser silently blocked it. Only the active scene's video
    // ever plays; every other scene's video stays paused. ----
    var soundToggle=document.getElementById('heroSoundToggle');
    // A scene can hold two cuts: a wide desktop video and a 9:16 mobile video.
    // Pick whichever one CSS is actually showing at the current width, so the
    // slider only ever plays/pauses/times the visible clip and never the
    // hidden sibling (which is what left the mobile video frozen before).
    var mqMobile=window.matchMedia('(max-width:640px)');
    function sceneVideo(sc){
      if(!sc) return null;
      var d=sc.querySelector('.hero-scene-video--desktop');
      var m=sc.querySelector('.hero-scene-video--mobile');
      if(mqMobile.matches && m) return m;
      if(d) return d;
      if(m) return m;
      return sc.querySelector('.hero-scene-video');
    }
    function activeVideo(){ var sc=scenes[cur]; return sc?sceneVideo(sc):null; }
    function updateSoundToggle(){
      if(!soundToggle) return;
      var v=activeVideo();
      if(!v){ soundToggle.hidden=true; return; }
      soundToggle.hidden=false;
      var on=!v.muted;
      soundToggle.setAttribute('aria-pressed', on?'true':'false');
      var label=soundToggle.querySelector('.label');
      if(label) label.textContent=on?'Sound on':'Sound off';
    }
    function tryUnmute(v){
      v.muted=false;
      var p=v.play();
      if(p&&p.catch){ p.catch(function(){ v.muted=true; v.play().catch(function(){}); updateSoundToggle(); }); }
    }
    function playSceneVideo(sc,slide){
      var v=sceneVideo(sc);
      if(!v) return;
      // pause the other cut so a hidden video never plays alongside the shown one
      [].slice.call(sc.querySelectorAll('.hero-scene-video')).forEach(function(o){ if(o!==v) o.pause(); });
      v.currentTime=0;
      if(slide) slide.classList.remove('collapse-words');
      tryUnmute(v);
    }
    function pauseSceneVideo(sc){
      if(!sc) return;
      [].slice.call(sc.querySelectorAll('.hero-scene-video')).forEach(function(v){ v.pause(); });
    }

    // ---- hero words timing (video slides only): the eyebrow/headline/
    // subtitle show for the video's first 7 seconds, then collapse — shrink
    // and slide down toward the CTA button — leaving just the CTA on screen
    // for the rest of the clip. Driven off the video's own 'timeupdate'
    // rather than a timer, so it stays in sync even if playback is paused
    // (hover) and resumed. ----
    var WORDS_VISIBLE=7;
    function updateWordsVisibility(v){
      var slide=slides[cur];
      if(!slide) return;
      var show = v.currentTime<WORDS_VISIBLE;
      slide.classList.toggle('collapse-words', !show);
    }
    scenes.forEach(function(sc,k){
      [].slice.call(sc.querySelectorAll('.hero-scene-video')).forEach(function(v){
        v.addEventListener('timeupdate',function(){ if(k===cur && v===activeVideo()) updateWordsVisibility(v); });
      });
      if(k===cur){ playSceneVideo(sc,slides[k]); } else { pauseSceneVideo(sc); }
    });
    if(soundToggle){
      soundToggle.addEventListener('click',function(){
        var v=activeVideo();
        if(!v) return;
        v.muted=!v.muted;
        if(!v.muted){ v.play().catch(function(){}); }
        updateSoundToggle();
      });
    }
    updateSoundToggle();

    // if the viewport crosses the mobile/desktop breakpoint, swap which cut
    // plays for the current slide (restart it from 0) without disturbing the
    // rotation, and re-arm the ended/timer advance for the now-active video.
    function onBreakpointChange(){
      var sc=scenes[cur];
      if(!sc) return;
      playSceneVideo(sc,slides[cur]);
      updateSoundToggle();
      start();
    }
    if(mqMobile.addEventListener){ mqMobile.addEventListener('change',onBreakpointChange); }
    else if(mqMobile.addListener){ mqMobile.addListener(onBreakpointChange); }

    // sound on by default — including mobile. Phones (and most browsers) block
    // unmuted autoplay until the visitor makes a gesture, so the video starts
    // muted; the instant they first touch/click anywhere, unmute the active
    // hero video and reflect it in the toggle. Fires once. Taps on the sound
    // toggle itself are left to its own handler so they don't double-flip.
    (function(){
      function cleanup(){
        document.removeEventListener('touchend',firstGestureUnmute);
        document.removeEventListener('pointerdown',firstGestureUnmute);
        document.removeEventListener('click',firstGestureUnmute);
      }
      function firstGestureUnmute(e){
        if(e&&e.target&&e.target.closest&&e.target.closest('#heroSoundToggle')){ cleanup(); return; }
        var v=activeVideo();
        if(v&&v.muted){ v.muted=false; v.play().catch(function(){}); updateSoundToggle(); }
        cleanup();
      }
      document.addEventListener('touchend',firstGestureUnmute,{passive:true});
      document.addEventListener('pointerdown',firstGestureUnmute,{passive:true});
      document.addEventListener('click',firstGestureUnmute);
    })();

    function setActive(i){slides.forEach(function(s,k){s.classList.toggle('active',k===i)});dots.forEach(function(d,k){d.classList.toggle('active',k===i)});scenes.forEach(function(sc,k){sc.classList.toggle('active',k===i)});}

    function go(n){
      var next=(n+slides.length)%slides.length;
      if(next===cur||animating) return;
      var curEl=slides[cur], nextEl=slides[next];
      var curScene=scenes[cur], nextScene=scenes[next];
      dots.forEach(function(d,i){d.classList.toggle('active',i===next)});
      pauseSceneVideo(curScene);
      if(nextScene) nextScene.classList.add('active');
      playSceneVideo(nextScene,nextEl);

      if(reduce||!hasGsap){ setActive(next); cur=next; updateSoundToggle(); start(); return; }

      animating=true;
      nextEl.classList.add('active');
      gsap.set(nextEl,{opacity:0,scale:.97,y:20,filter:'blur(9px)'});

      var tl=gsap.timeline({defaults:{overwrite:'auto'},onComplete:function(){
        curEl.classList.remove('active');
        if(curScene) curScene.classList.remove('active');
        gsap.set(curEl,{clearProps:'opacity,scale,filter,transform'});
        gsap.set(nextEl,{clearProps:'opacity,scale,filter,transform'});
        animating=false;
      }});
      // outgoing: settles up and out, softly blurring away
      tl.to(curEl,{opacity:0,scale:1.02,y:-20,filter:'blur(9px)',duration:.7,ease:'power2.inOut'},0)
        // incoming: rises in from below and sharpens into focus, slightly
        // overlapping the outgoing slide's fade for a true cross-dissolve
        .to(nextEl,{opacity:1,scale:1,y:0,filter:'blur(0px)',duration:1.05,ease:'power3.out'},.28);
      // a soft breath through the tea-steam fog, timed to the midpoint
      if(heroFog){ tl.to(heroFog,{opacity:.55,duration:.55,ease:'sine.inOut',yoyo:true,repeat:1},.1); }
      // the four-hour colour arc flashes brighter as the new slide settles in
      if(heroArc){ tl.to(heroArc,{opacity:1,filter:'brightness(1.9)',duration:.45,ease:'power2.out',yoyo:true,repeat:1},.32); }
      // the kanji watermark gives a slow, barely-there breathe
      if(heroKanji){ tl.to(heroKanji,{scale:1.03,duration:.6,ease:'sine.out',yoyo:true,repeat:1},.28); }

      cur=next;
      updateSoundToggle();
      start();
    }
    function next(){go(cur+1);}

    // ---- auto-advance: a plain timer for slides without video, or a
    // one-time 'ended' listener on the active video for slides that have
    // one — so a video slide always finishes playing before the slider
    // moves on, rather than cutting away at a fixed 6.2s mark. ----
    var videoEndedEl=null, videoEndedFn=null;
    function start(){
      if(reduce) return;
      stop();
      var v=activeVideo();
      if(v){
        if(v.ended){ next(); return; }
        videoEndedFn=function(){ v.removeEventListener('ended',videoEndedFn); next(); };
        videoEndedEl=v;
        v.addEventListener('ended',videoEndedFn);
      } else {
        timer=setInterval(next,DUR);
      }
    }
    function stop(){
      if(timer){ clearInterval(timer); timer=null; }
      if(videoEndedEl&&videoEndedFn){ videoEndedEl.removeEventListener('ended',videoEndedFn); videoEndedEl=null; videoEndedFn=null; }
    }
    dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.i);})});
    var hero=document.querySelector('.mxw-hero');
    if(hero){hero.addEventListener('mouseenter',stop);hero.addEventListener('mouseleave',start);
      var x0=null;hero.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
      hero.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45){dx<0?next():go(cur-1);}x0=null;},{passive:true});}
    start();
  })();

  // ---- hero particles: soft drifting motes (sage + parchment) across the
  // hero backdrop, pure canvas so it stays light with many particles at once.
  // Skipped entirely under prefers-reduced-motion, and paused when the tab
  // is hidden so it never burns cycles in the background. ----
  (function(){
    if(reduce) return;
    var canvas=document.querySelector('.hero-particles');
    var hero=document.querySelector('.mxw-hero');
    if(!canvas||!hero||!canvas.getContext) return;
    var ctx=canvas.getContext('2d');
    var w=0,h=0,dpr=Math.min(window.devicePixelRatio||1,2);
    var particles=[],raf=null;
    var COUNT=42;

    function resize(){
      w=hero.clientWidth; h=hero.clientHeight;
      canvas.width=Math.max(1,w*dpr); canvas.height=Math.max(1,h*dpr);
      canvas.style.width=w+'px'; canvas.style.height=h+'px';
      ctx.setTransform(dpr,0,0,dpr,0,0);
    }
    function spawn(){
      return {
        x:Math.random()*w,
        r:1.1+Math.random()*2.2,
        speed:0.16+Math.random()*0.32,
        drift:(Math.random()-0.5)*0.35,
        sway:Math.random()*Math.PI*2,
        swaySpeed:0.004+Math.random()*0.006,
        alpha:0.08+Math.random()*0.22,
        hue:Math.random()<0.5?'167,187,102':'251,245,225'
      };
    }
    function init(){
      particles=[];
      for(var i=0;i<COUNT;i++){ var p=spawn(); p.y=Math.random()*h; particles.push(p); }
    }
    function step(){
      ctx.clearRect(0,0,w,h);
      particles.forEach(function(p){
        p.sway+=p.swaySpeed;
        p.y-=p.speed;
        p.x+=p.drift+Math.sin(p.sway)*0.25;
        if(p.y<-10){ var np=spawn(); np.y=h+10; for(var k in np){ p[k]=np[k]; } }
        if(p.x<-10) p.x=w+10; if(p.x>w+10) p.x=-10;
        ctx.beginPath();
        ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle='rgba('+p.hue+','+p.alpha+')';
        ctx.fill();
      });
      raf=requestAnimationFrame(step);
    }
    resize(); init(); step();
    window.addEventListener('resize',function(){ resize(); });
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){ if(raf) cancelAnimationFrame(raf); raf=null; }
      else if(!raf){ step(); }
    });
  })();

  // ---- header daypart signal: shows the VISITOR's own local time-of-day
  // ritual (not the shop's timezone) — Date's getHours() already resolves
  // against the browser's local timezone, and we cross-check that against
  // Intl's resolved IANA zone so the tooltip can show exactly what was used. ----
  (function(){
    var el=document.getElementById('daypartSignal');
    var dot=document.getElementById('dsDot'), label=document.getElementById('dsLabel');
    var headBar=document.querySelector('.site-head');
    if(!el||!dot||!label) return;

    // Same boundaries as the approved daypart-redesign concept, so the site
    // and the pitch never disagree on what hour belongs to which ritual.
    var RANGES=[
      {id:'morning',   name:'Morning',   from:6,  to:10},
      {id:'afternoon', name:'Afternoon', from:12, to:16},
      {id:'evening',   name:'Evening',   from:20, to:22},
      {id:'nightlife', name:'Nightlife', from:22, to:24} // + wraps to hour<6, handled below
    ];

    function currentRange(hour){
      for(var i=0;i<RANGES.length;i++){
        var r=RANGES[i];
        if(r.id==='nightlife'){ if(hour>=22||hour<6) return r; }
        else if(hour>=r.from && hour<r.to) return r;
      }
      return null; // between rituals — matches the reference concept's fallback
    }

    function update(){
      var now=new Date();
      var range=currentRange(now.getHours());
      var tz='local time';
      try{ tz=Intl.DateTimeFormat().resolvedOptions().timeZone||tz; }catch(e){}
      var timeStr=now.toLocaleTimeString([], {hour:'numeric',minute:'2-digit'});
      var label_=range?range.name+' mode':'Between rituals';

      // toggle on both the small chip AND the header bar, so the whole
      // nav gets a slight tint of that hour's colour, not just the dot
      RANGES.forEach(function(r){
        var on=!!range && r.id===range.id;
        el.classList.toggle('is-'+r.id, on);
        if(headBar) headBar.classList.toggle('is-'+r.id, on);
      });
      label.textContent=label_;
      el.title=timeStr+' · '+tz+' — '+label_;
      el.setAttribute('aria-label','Current time '+timeStr+' ('+tz+') — '+label_);
    }

    update();
    setInterval(update,60000); // re-check every minute so it flips the instant a boundary passes
    document.addEventListener('visibilitychange',function(){ if(!document.hidden) update(); });
  })();

  // ---- day-arc: layered daypart carousel. The timeline auto-advances
  // through whichever tabs aren't disabled (Evening/Nightlife are marked
  // "soon" and disabled until their products ship), crossfading the
  // matching ritual layer in .daypart-stack (grid-stacked, only one visible
  // at a time). Click a tab to jump straight there; hover pauses. Mirrors
  // the hero slider's auto-rotate pattern above. ----
  (function(){
    var stops=[].slice.call(document.querySelectorAll('.arc-stop'));
    var layers=[].slice.call(document.querySelectorAll('.daypart-stack .daypart'));
    if(!stops.length||!layers.length) return;
    var enabled=stops.map(function(s,i){return i;}).filter(function(i){return !stops[i].disabled;});
    if(!enabled.length) enabled=[0];

    // start on whichever ritual matches the visitor's current local hour, so
    // an afternoon visitor lands on the afternoon layer first instead of
    // always morning — same boundaries as the header daypart signal above,
    // only applied when that ritual is actually enabled (not "soon").
    var hour=new Date().getHours();
    var startIndex=enabled[0];
    if(hour>=12&&hour<16){
      var afternoonIdx=stops.findIndex(function(s){ return s.dataset.mode==='afternoon'; });
      if(afternoonIdx>-1 && enabled.indexOf(afternoonIdx)>-1) startIndex=afternoonIdx;
    }
    var cur=startIndex,timer=null,DUR=7000;
    function setActive(i){
      stops.forEach(function(s,k){ s.classList.toggle('is-active',k===i); });
      layers.forEach(function(l,k){ l.classList.toggle('active',k===i); });
    }
    function go(n){ cur=(n+stops.length)%stops.length; setActive(cur); }
    function next(){
      var idx=enabled.indexOf(cur);
      go(enabled[(idx+1)%enabled.length]);
    }
    function start(){ if(!reduce){ stop(); timer=setInterval(next,DUR); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    stops.forEach(function(s,i){ if(s.disabled) return; s.addEventListener('click',function(){ go(i); start(); }); });
    var rail=document.querySelector('.dayarc-rail');
    if(rail){ rail.addEventListener('mouseenter',stop); rail.addEventListener('mouseleave',start); }
    setActive(cur);
    start();
  })();

  // ---- region configurator: country -> origin, auto-rotate, disabled countries ----
  document.querySelectorAll('.mxw-config').forEach(function(root){
    var countries=[].slice.call(root.querySelectorAll('.cfg-country'));
    var originRows=[].slice.call(root.querySelectorAll('.cfg-origins'));
    var panels=[].slice.call(root.querySelectorAll('.cfg-panel'));
    if(!countries.length) return;
    var cc=0,oo=0,timer=null,DUR=4600;
    function originsOf(c){return [].slice.call(root.querySelectorAll('.cfg-tab[data-c="'+c+'"]'));}
    function showPanel(c,o){panels.forEach(function(p){p.classList.toggle('active',p.dataset.c==c&&p.dataset.o==o);});}
    function setOrigin(o){var ors=originsOf(cc);if(!ors.length){oo=0;showPanel(cc,0);return;}oo=(o+ors.length)%ors.length;ors.forEach(function(t,i){t.classList.toggle('active',i===oo);});showPanel(cc,oo);}
    function setCountry(c){cc=c;oo=0;countries.forEach(function(x,i){x.classList.toggle('active',i===cc);x.setAttribute('aria-selected',i===cc?'true':'false');});originRows.forEach(function(r){r.classList.toggle('active',r.dataset.c==cc);});var ors=originsOf(cc);if(ors.length){setOrigin(0);}else{showPanel(cc,0);}}
    function tick(){var ors=originsOf(cc);if(ors.length>1){setOrigin(oo+1);}}
    function start(){if(!reduce){stop();timer=setInterval(tick,DUR);}} function stop(){if(timer){clearInterval(timer);timer=null;}}
    countries.forEach(function(btn){btn.addEventListener('click',function(){if(btn.classList.contains('disabled')||btn.disabled)return;setCountry(+btn.dataset.c);start();});});
    root.querySelectorAll('.cfg-tab').forEach(function(t){t.addEventListener('click',function(){cc=+t.dataset.c;setOrigin(+t.dataset.o);start();});});
    root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',start);
    setCountry(0); start();
  });

  // ---- product carousel: holographic coverflow (desktop/tablet) + native swipe (mobile) ----
  (function(){
    var root=document.getElementById('mxw-carousel');
    if(!root) return;
    var track=root.querySelector('.carousel-track');
    var originals=[].slice.call(track.children);
    var n=originals.length;
    if(!n) return;
    var thumbs=[].slice.call(root.querySelectorAll('.car-thumb'));
    var prevBtn=root.querySelector('.car-prev'), nextBtn=root.querySelector('.car-next');
    var mq=window.matchMedia('(max-width:640px)');

    function syncThumbsByIndex(i){
      thumbs.forEach(function(t,ti){ t.classList.toggle('active',ti===i); });
    }
    function resetTrack(){
      track.innerHTML='';
      originals.forEach(function(c){ c.style.cssText=''; c.classList.remove('active'); track.appendChild(c); });
    }

    // ---------- mobile: native scroll-snap, no clones, no custom drag ----------
    // Starts centered on the flagship product (marked with .car-flagship in Liquid),
    // falling back to the first product if no flagship tag is present.
    function setupMobile(){
      var cards=[].slice.call(track.children);
      var flagshipIndex=cards.findIndex(function(c){ return c.classList.contains('car-flagship'); });
      var startIndex=flagshipIndex>=0?flagshipIndex:0;

      function centerCard(i,smooth){
        var c=cards[(i+cards.length)%cards.length];
        if(!c) return;
        var tr=track.getBoundingClientRect(), cr=c.getBoundingClientRect();
        var delta=(cr.left+cr.width/2)-(tr.left+tr.width/2);
        track.scrollBy({left:delta,behavior:smooth?'smooth':'auto'});
      }

      cards.forEach(function(c,i){ c.classList.toggle('active',i===startIndex); });
      syncThumbsByIndex(startIndex);
      requestAnimationFrame(function(){ centerCard(startIndex,false); });

      var ticking=false;
      function nearestIndex(){
        var tr=track.getBoundingClientRect(), center=tr.left+tr.width/2, best=0, bestD=Infinity;
        cards.forEach(function(c,i){
          var r=c.getBoundingClientRect(), d=Math.abs((r.left+r.width/2)-center);
          if(d<bestD){ bestD=d; best=i; }
        });
        return best;
      }
      function onScroll(){
        if(ticking) return; ticking=true;
        requestAnimationFrame(function(){
          var idx=nearestIndex();
          cards.forEach(function(c,i){ c.classList.toggle('active',i===idx); });
          syncThumbsByIndex(idx);
          ticking=false;
        });
      }
      track.addEventListener('scroll',onScroll,{passive:true});

      var thumbHandlers=thumbs.map(function(t){
        var h=function(){ centerCard(+t.dataset.index,true); };
        t.addEventListener('click',h);
        return {t:t,h:h};
      });

      return function teardown(){
        track.removeEventListener('scroll',onScroll);
        thumbHandlers.forEach(function(o){ o.t.removeEventListener('click',o.h); });
      };
    }

    // ---------- desktop/tablet: holographic coverflow ----------
    function setupDesktop(){
      var cleanups=[];
      function on(el,ev,fn,opts){ el.addEventListener(ev,fn,opts); cleanups.push(function(){ el.removeEventListener(ev,fn,opts); }); }

      if(n>1){
        var fragBefore=document.createDocumentFragment();
        var fragAfter=document.createDocumentFragment();
        originals.forEach(function(c){ fragAfter.appendChild(c.cloneNode(true)); });
        originals.forEach(function(c){ fragBefore.appendChild(c.cloneNode(true)); });
        track.insertBefore(fragBefore, track.firstChild);
        track.appendChild(fragAfter);
      }
      var cards=[].slice.call(track.children);
      var base=n>1?n:0;
      var total=cards.length;
      var pos=base;
      var spacing=200;
      var DRAG_THRESHOLD=6;

      function measure(){
        var ref=cards[base]||cards[0];
        var w=ref.getBoundingClientRect().width||280;
        spacing=w*0.66;
      }
      function realIndex(i){ return ((Math.round(i)-base)%n+n)%n; }
      function render(p){
        for(var i=0;i<total;i++){
          var card=cards[i], off=i-p, ax=Math.abs(off);
          if(ax>3.5){ card.style.opacity='0'; card.style.pointerEvents='none'; card.classList.remove('active'); continue; }
          var x=off*spacing;
          var scale=Math.max(0.6,1-ax*0.17);
          var rot=Math.max(-40,Math.min(40,off*-28));
          var z=-ax*110;
          var op=Math.max(0,1-ax*0.34);
          card.style.transform='translate(-50%,-50%) translateX('+x.toFixed(1)+'px) translateZ('+z.toFixed(1)+'px) rotateY('+rot.toFixed(1)+'deg) scale('+scale.toFixed(3)+')';
          card.style.opacity=String(op);
          card.style.zIndex=String(200-Math.round(ax*20));
          card.classList.toggle('active',ax<0.02);
          card.style.pointerEvents = ax<1.5 ? 'auto':'none';
        }
      }
      function syncThumbs(){ syncThumbsByIndex(realIndex(pos)); }
      function noAnim(fn){ track.classList.add('no-anim'); fn(); void track.offsetWidth; track.classList.remove('no-anim'); }
      function recenter(){
        if(n<2) return;
        if(pos<base-n*0.5 || pos>base+n+n*0.5){
          var ri=realIndex(pos);
          noAnim(function(){ pos=base+ri; render(pos); });
        }
      }
      function goTo(target){
        pos=target; render(pos); syncThumbs();
        window.clearTimeout(root._rcT);
        root._rcT=window.setTimeout(recenter,480);
      }
      function nearestEquivalent(realI){
        if(n<2) return base+realI;
        var cur=Math.round(pos);
        var options=[base+realI, base+realI-n, base+realI+n];
        options.sort(function(a,b){return Math.abs(a-cur)-Math.abs(b-cur);});
        return options[0];
      }

      measure(); render(pos); syncThumbs();
      on(window,'resize',function(){ measure(); render(pos); });

      var maybeDragging=false, dragging=false, startX=0, startPos=pos, hist=[], activePointerId=null;
      on(track,'pointerdown',function(e){
        if(n<2) return;
        if(e.target.closest('a.btn, .car-thumb, .car-nav')) return;
        maybeDragging=true; dragging=false;
        startX=e.clientX; startPos=pos; hist=[{x:e.clientX,t:Date.now()}];
        activePointerId=e.pointerId;
      });
      on(track,'pointermove',function(e){
        if(!maybeDragging) return;
        var dx=e.clientX-startX;
        if(!dragging){
          if(Math.abs(dx)<DRAG_THRESHOLD) return;
          dragging=true;
          track.classList.add('dragging');
          try{track.setPointerCapture(activePointerId);}catch(err){}
        }
        e.preventDefault();
        pos=startPos-dx/spacing;
        render(pos);
        hist.push({x:e.clientX,t:Date.now()});
        if(hist.length>6) hist.shift();
      });
      function endDrag(e){
        if(!maybeDragging) return;
        maybeDragging=false;
        if(!dragging) return;
        dragging=false;
        track.classList.remove('dragging');
        var vel=0;
        if(hist.length>1){
          var a=hist[0], b=hist[hist.length-1], dt=b.t-a.t;
          if(dt>0) vel=(b.x-a.x)/dt;
        }
        goTo(Math.round(pos-vel*0.09));
      }
      on(track,'pointerup',endDrag);
      on(track,'pointercancel',endDrag);
      on(track,'pointerleave',function(e){ if(maybeDragging && e.buttons===0) endDrag(e); });

      cards.forEach(function(card){
        var link=card.querySelector('.card-img');
        if(!link) return;
        var h=function(e){
          if(!card.classList.contains('active')){ e.preventDefault(); goTo(cards.indexOf(card)); }
        };
        link.addEventListener('click',h);
        cleanups.push(function(){ link.removeEventListener('click',h); });
      });

      thumbs.forEach(function(t){
        var h=function(){ goTo(nearestEquivalent(+t.dataset.index)); };
        on(t,'click',h);
      });

      if(prevBtn){ var ph=function(){ goTo(Math.round(pos)-1); }; on(prevBtn,'click',ph); }
      if(nextBtn){ var nh=function(){ goTo(Math.round(pos)+1); }; on(nextBtn,'click',nh); }

      root.setAttribute('tabindex','0');
      on(root,'keydown',function(e){
        if(e.key==='ArrowLeft'){ goTo(Math.round(pos)-1); }
        else if(e.key==='ArrowRight'){ goTo(Math.round(pos)+1); }
      });

      on(root,'pointermove',function(e){
        var active=track.querySelector('.car-card.active');
        if(!active) return;
        var img=active.querySelector('.card-img');
        if(!img) return;
        var r=img.getBoundingClientRect();
        img.style.setProperty('--mx',(((e.clientX-r.left)/r.width)*100).toFixed(1)+'%');
        img.style.setProperty('--my',(((e.clientY-r.top)/r.height)*100).toFixed(1)+'%');
      });

      return function teardown(){
        cleanups.forEach(function(fn){ fn(); });
        window.clearTimeout(root._rcT);
      };
    }

    var mode=null, teardownFn=null;
    function setup(){
      if(teardownFn){ teardownFn(); teardownFn=null; }
      resetTrack();
      if(mq.matches){ mode='mobile'; teardownFn=setupMobile(); }
      else { mode='desktop'; teardownFn=setupDesktop(); }
    }
    setup();

    var resizeT=null;
    window.addEventListener('resize',function(){
      clearTimeout(resizeT);
      resizeT=setTimeout(function(){
        var wantMobile=mq.matches;
        if((wantMobile && mode!=='mobile') || (!wantMobile && mode!=='desktop')) setup();
      },150);
    });
  })();

  // ---- affiliate code check + share ----
  var affbtn=document.getElementById('affbtn');
  if(affbtn){
    var codes=window.MXW_AFFILIATE_CODES||{};
    var shareText=window.MXW_AFFILIATE_SHARE_TEXT||'Check this out:';
    var input=document.getElementById('affcode');
    var base=input.getAttribute('data-base')||'?ref=';
    var shareWrap=document.getElementById('affShare');
    var shareNative=document.getElementById('affShareNative');
    var shareX=document.getElementById('affShareX');
    var shareFb=document.getElementById('affShareFb');
    var shareWa=document.getElementById('affShareWa');
    var shareCopy=document.getElementById('affShareCopy');

    function toAbsolute(u){ return /^https?:\/\//i.test(u) ? u : 'https://'+u; }

    function fallbackCopy(text,done){
      var ta=document.createElement('textarea');
      ta.value=text; ta.style.position='fixed'; ta.style.opacity='0';
      document.body.appendChild(ta); ta.focus(); ta.select();
      try{ document.execCommand('copy'); done(); }catch(err){}
      document.body.removeChild(ta);
    }

    function showShare(link){
      if(!shareWrap) return;
      var url=toAbsolute(link);
      if(shareX) shareX.href='https://twitter.com/intent/tweet?text='+encodeURIComponent(shareText)+'&url='+encodeURIComponent(url);
      if(shareFb) shareFb.href='https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url);
      if(shareWa) shareWa.href='https://wa.me/?text='+encodeURIComponent(shareText+' '+url);
      if(shareNative){
        if(navigator.share){
          shareNative.hidden=false;
          shareNative.onclick=function(){ navigator.share({title:document.title,text:shareText,url:url}).catch(function(){}); };
        } else {
          shareNative.hidden=true;
        }
      }
      if(shareCopy){
        shareCopy.onclick=function(){
          var old=shareCopy.textContent;
          var done=function(){ shareCopy.textContent='Copied!'; setTimeout(function(){shareCopy.textContent=old;},1800); };
          if(navigator.clipboard && navigator.clipboard.writeText){
            navigator.clipboard.writeText(url).then(done).catch(function(){ fallbackCopy(url,done); });
          } else { fallbackCopy(url,done); }
        };
      }
      shareWrap.hidden=false;
    }
    function hideShare(){ if(shareWrap) shareWrap.hidden=true; }

    function runAff(){var code=(input.value||'').trim().toUpperCase();var msg=document.getElementById('affmsg');
      if(!code){msg.className='aff-msg no';msg.textContent='Enter your code to continue.';hideShare();return;}
      if(codes[code]){var link=base+code;msg.className='aff-msg ok';msg.textContent='✓ Welcome back — '+codes[code]+' unlocked. Your link: '+link;showShare(link);}
      else{msg.className='aff-msg no';msg.textContent='That code isn’t recognised. Affiliate codes are issued by invitation.';hideShare();}}
    affbtn.addEventListener('click',runAff);
    input.addEventListener('keydown',function(e){if(e.key==='Enter')runAff();});
  }

  if(reduce) return;
  // ---- scroll: progress rail, hero parallax/fade, image parallax ----
  var rail=document.getElementById('mxw-rail'), sleaf=document.getElementById('mxw-sleaf');
  var heroInner=document.querySelector('.hero-inner'), heroKanji=document.querySelector('.hero-kanji');
  // Never apply the hero scroll parallax/fade on the password gate: the login
  // form lives inside .hero-inner there, and dimming/translating it on scroll
  // made the field + button fade out and drop focus on mobile. Homepage heroes
  // (no .password-page) keep the effect.
  var isPasswordGate = !!document.querySelector('.password-page');
  var pimgs=[].slice.call(document.querySelectorAll('.card-img img'));
  var ticking=false;
  function onScroll(){var y=window.scrollY||window.pageYOffset,vh=window.innerHeight;var docH=document.documentElement.scrollHeight-vh;
    if(rail)rail.style.width=(docH>0?(y/docH*100):0)+'%';
    if(sleaf)sleaf.classList.toggle('show',y>200);
    if(heroInner&&!isPasswordGate&&y<vh){var p=y/vh;heroInner.style.transform='translateY('+(y*0.18)+'px)';heroInner.style.opacity=(1-p*1.15).toFixed(3);}
    if(heroKanji&&y<vh){heroKanji.style.transform='translate(-50%,'+(-53-y*0.04)+'%)';}
    pimgs.forEach(function(img){var r=img.getBoundingClientRect();var dd=((r.top+r.height/2)-vh/2)/vh;img.style.transform='translateY('+(dd*-14)+'px) scale(1.06)';});
    ticking=false;}
  // NOTE: intentionally NOT bound to 'resize'. Binding it there used to
  // recompute this scroll-position-based opacity/transform whenever the
  // viewport size changed — including the mobile on-screen keyboard opening,
  // which shrinks window.innerHeight without the page actually scrolling.
  // That shrunk vh alone was enough to push the fade formula toward 0,
  // making the hero content (and any button inside it, e.g. the password
  // page's "Enter" button) fade out the instant a visitor tapped a text
  // field on mobile. Real scroll position changes still update it via the
  // 'scroll' listener below, so nothing about the intended effect is lost.
  window.addEventListener('scroll',function(){if(!ticking){requestAnimationFrame(onScroll);ticking=true;}},{passive:true});
  onScroll();
})();
